/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FC, useEffect } from "react"
import { isMobile } from "react-device-detect";
import { Scrollbar, Mousewheel, Navigation, Pagination } from "swiper/modules";
// @ts-ignore
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from "swiper/react";
import ProductCard from "../../../components/ProductCard";
import homeStore from "../store/homeStore";
import { observer } from "mobx-react-lite";
import Skeleton from "react-loading-skeleton";

const NewProducts: FC = () => {
    useEffect(() => {

    }, []);


    return (
    <div className="flex flex-col gap-4">
      <h2 className=" text-2xl font-bold">Новинки</h2>
      <div className="w-[100vw] md:w-full h-[450px] md:h-full">
        <Swiper
          modules={[Navigation, Scrollbar, Mousewheel, Pagination]} // Добавляем Mousewheel модуль
          spaceBetween={5}
          className={"md:bg-white  md:rounded-[15px] relative md:shadow-[0px_2px_20px_10px_rgba(0,0,0,0.10)] " + (isMobile ? "!overflow-visible" : "")}
          slidesPerView={isMobile ? 2 : 5}
          // centeredSlides={isMobile}
          // slideToClickedSlide={true}
          // grabCursor={true}
          mousewheel={{
            // Активируем прокрутку колесом мыши/трекпадом
            forceToAxis: true, // Прокрутка только по горизонтали
            releaseOnEdges: true, // Освобождение при достижении края
            sensitivity: 1, // Чувствительность прокрутки
          }}
          scrollbar={{
            hide: false,
            draggable: true,
            snapOnRelease: true,
          }}
          freeMode={{
            // Режим свободной прокрутки
            // enabled: true,
            // momentum: true, // Инерция при прокрутке
            momentumRatio: 1,
            momentumBounce: true,
          }}
          pagination={isMobile}
          navigation={
            !isMobile
              ? {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                  disabledClass: "swiper-button-disabled",
                }
              : false
            }
        >
     {homeStore.newProducts.length > 0
            ? homeStore.newProducts.map((i, index) => (
                <SwiperSlide
                  key={i.artikul}
                   className={
                    isMobile
                      ? "!w-[200px] border-r-1 border-r-[#54545657] last:border-r-0 !h-auto"
                      : "border-r-1 border-r-[#54545657] last:border-r-0 !h-auto !w-[246px]"
                  }
                >
                  <ProductCard product={i} className="  h-full" />
                </SwiperSlide>
              ))
            : Array.from({ length: isMobile ? 2 : 5 }).map((_, idx) => (
                <SwiperSlide
                  key={`popular-skeleton-${idx}`}
                  className={
                    isMobile
                      ? "!w-[200px] border-r-1 border-r-[#54545657] last:border-r-0 !h-auto"
                      : "border-r-1 border-r-[#54545657] last:border-r-0 !h-auto"
                  }
                >
                  <div className={!isMobile ? "p-[20px]" : "py-[20px] px-[10px]"}>
                    <div className={!isMobile ? "w-[210px] mb-[20px]" : "w-full max-w-[185px] py-[12px] mx-auto"}>
                      <Skeleton
                        height={isMobile ? 110 : 154}
                        width={isMobile ? 150 : 210}
                        baseColor="#f3f3f3"
                        highlightColor="#ecebeb"
                        className={isMobile ? "rounded" : "rounded"}
                      />
                      <div className="flex flex-col gap-2 mt-[10px]">
                        <Skeleton width={isMobile ? 80 : 120} height={16} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                        <Skeleton width={isMobile ? "90%" : 180} height={14} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                      </div>
                      <div className="flex flex-col mt-[20px] gap-2">
                        <Skeleton width={120} height={12} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                        <Skeleton width={140} height={12} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-[12px]">
                      <Skeleton width={70} height={20} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                      <Skeleton width={46} height={47} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                    </div>
                    <div className="mt-[12px]">
                      <Skeleton height={45} baseColor="#f3f3f3" highlightColor="#ecebeb" />
                    </div>
                  </div>
                </SwiperSlide>
              ))}

          {!isMobile && (
            <>
              <div className="swiper-button-prev after:text-black after:text-xl"></div>
              <div className="swiper-button-next after:text-black after:text-xl"></div>
            </>
          )}
        </Swiper>
      </div>
    </div>
    )
}

export default observer(NewProducts);